export default __webpack_public_path__ + "static/media/money-out.a0714ba8.svg";